import { Injectable, Injector } from "@angular/core";
import { CoreLogService } from "../services/log.service";
import { UserHelperService } from "../services/userHelper.service";
import { CircularInjectionHelper } from "../services/circularInjectionHelper";
import { YourAppServer } from "../services/YourAppServer.service";
import { CoreCOMService } from "../services/com.service";
import { SafeFileSystem } from "../services/safeFileSystem.service";
import { HttpService } from "../services/http.service";
import { HttpClient } from "@angular/common/http";
import { CoreLogInjector } from "../shared/logInjector";
import { ContentType, SnackBarMessageType } from "../shared/contentTypes";
import { BlackWhiteListDeviceDataModel } from "../shared/models";
import { ObjectObserverFactory } from "../services/objectObserverFactory";
import Utils from "../shared/utils";
import { ClientType } from "../services/com/comEnvironmentClient";
import { SnackBarService, snackBarMessageKey } from "../services/snackBar.service";
import { SettingsService } from "../services/settings.service";
import { MatDialog } from "@angular/material";

@Injectable({
  providedIn: "root"
})
export class UserLoginStatusProvider {

  constructor(private _coreLogService: CoreLogService,
    private _snackBarService: SnackBarService,
    coreCOMService: CoreCOMService,
    httpClient: HttpClient,
    matDialog: MatDialog,
    safeFileSystem: SafeFileSystem,
    coreLogInjector: CoreLogInjector,
    private _objObsInjectHelper: CircularInjectionHelper,
    private _userHelperService: UserHelperService,
    private _settingsService: SettingsService,
    private _injector: Injector) {
    const me = this;
    // CoreLogInjector must inject and init as first in app.component.ts, to set SafeFileSystem to CoreLogService (else it create a circular dependency)
    coreLogInjector.init(coreCOMService.environment.client);

    // initilize it at start of the app
    const yourAppServer = new YourAppServer(coreCOMService, me._coreLogService, new HttpService(httpClient, matDialog), me._settingsService, me._injector);
    me._objObsInjectHelper.Initilize(coreCOMService, safeFileSystem, yourAppServer, me._injector);
  }

  // check the user device is in blacklist status in the first step of application Loading
  public checkLoginStatusAndBlackListDevice(): Promise<boolean> {
    const me = this;
    return new Promise((resolve, reject) => {
      me.checkLoginStatus().then(async (result) => {
        const client = me._objObsInjectHelper.coreCOMService.environment.client;
        const my_device_manufacturer = client.manufacturer.toLowerCase();
        const my_device_model = client.model.toLowerCase();
        let my_device_platform = "android";
        switch (client.type) {
          case ClientType.android: {
            break;
          }
          case ClientType.browser: {
            my_device_platform = "browser";
            break;
          }
          case ClientType.ios: {
            my_device_platform = "ios";
            break;
          }
          case ClientType.linux: {
            my_device_platform = "linux";
            break;
          }
          case ClientType.osx: {
            my_device_platform = "osx";
            break;
          }
          case ClientType.windows: {
            my_device_platform = "windows";
            break;
          }
          default: {
            my_device_platform = "undefined";
            break;
          }
        }
        const my_device_version = Utils.GetNumberFromVersion(client.version.toLowerCase(), 10000);
        const BlackWhiteListService = ObjectObserverFactory.GetObjectObserverByInjectionHelper<BlackWhiteListDeviceDataModel>(ContentType.BlackWhiteList, me._objObsInjectHelper);
        try {
          const blockedDevices = await BlackWhiteListService.GetObjectsByFilter((bw_device) => {
            if (!bw_device.deleted && bw_device.blocked) {
              const bw_device_version = Utils.GetNumberFromVersion(bw_device.version_device.toLowerCase(), -10000);
              if ((bw_device.manufacturer.toLowerCase() === my_device_manufacturer) && (bw_device.model.toLowerCase() === my_device_model) && (bw_device.model.toLowerCase() === my_device_model) && (bw_device.platform.toLowerCase() === my_device_platform) && (bw_device_version >= my_device_version)) {
                return true;
              }
            }
            return false;
          });

          if (blockedDevices.length > 0) {
            // TODO die blockedDevices[0].description mit anzeigen?
            me._snackBarService.ShowMessage(snackBarMessageKey.unsupported, SnackBarMessageType.Error);
          }
        } catch (error) {
          me._coreLogService.error("UserLoginStatusProvider.checkLoginStatusAndBlackListDevice()", "try", error);
        }

        resolve(result);
      }).catch(reject);
    });
  }

  // check the user login status in the first step of application Loading
  public checkLoginStatus(): Promise<boolean> {
    const me = this;
    return new Promise((resolve, reject) => {
      me._objObsInjectHelper.yourAppServer.Auth.SingInFromStorage()
        .then((success) => {
          if (success) {
            if (me._objObsInjectHelper.yourAppServer.Auth.IsCustomer) {
              me._userHelperService.IsRegistrationConfirmed()
                .then((isRegistered) => {
                  if (!isRegistered) {
                    me._objObsInjectHelper.yourAppServer.Auth.SignInAnonymousOrNobody()
                      .then(signInResponse => {
                        resolve(signInResponse);
                      })
                      .catch(e => {
                        me._objObsInjectHelper.coreLogService.error("UserLoginStatusProvider.initializeUserAuth", "_yourAppServer.Auth.SingInFromStorage else - IsRegistrationConfirmed catch", e);
                        reject();
                      });
                  } else {
                    resolve(true);
                  }
                })
                .catch((e) => {
                  me._objObsInjectHelper.coreLogService.error("UserLoginStatusProvider.initializeUserAuth", "_userHelperServiceService.IsRegistrationConfirmed", e);
                  reject();
                });
            } else {
              resolve(true);
            }
          } else {
            me._objObsInjectHelper.yourAppServer.Auth.SignInAnonymousOrNobodyIfNeed()
              .then((response) => {
                resolve(response);
              })
              .catch(e => {
                me._objObsInjectHelper.coreLogService.error("UserLoginStatusProvider.initializeUserAuth", "_yourAppServer.Auth.SingInFromStorage else - IsRegistrationConfirmed catch", e);
                reject();
              });
          }
        })
        .catch((e) => {
          me._objObsInjectHelper.coreLogService.error("UserLoginStatusProvider.initializeUserAuth", "_yourAppServer.Auth.SingInFromStorage", e);
          reject();
        });
    });
  }
}
